/**
 * Period-over-period change pill. `lowerIsBetter` flips the good/bad colouring
 * (e.g. escalation rate, response time). Colour is never the only signal: arrow + sign included.
 */
export default function TrendBadge({ delta, lowerIsBetter = false, suffix = '%', label = 'vs previous period' }) {
  if (delta == null || !Number.isFinite(delta)) {
    return <span className="cb-trend cb-trend--flat" title="No comparison available">— n/a</span>;
  }
  const rounded = Math.round(delta * 10) / 10;
  const dir = rounded > 0 ? 'up' : rounded < 0 ? 'down' : 'flat';
  const good = dir === 'flat' ? null : (dir === 'up') !== lowerIsBetter;
  const tone = good === null ? 'flat' : good ? 'good' : 'bad';
  const icon = dir === 'up' ? 'bi-arrow-up-short' : dir === 'down' ? 'bi-arrow-down-short' : 'bi-dash';
  const sign = rounded > 0 ? '+' : '';
  return (
    <span className={`cb-trend cb-trend--${tone}`} title={label}>
      <i className={`bi ${icon}`} aria-hidden="true" />
      {sign}{rounded}{suffix}
      <span className="visually-hidden"> {dir === 'flat' ? 'no change' : dir === 'up' ? 'increase' : 'decrease'} {label}</span>
    </span>
  );
}
